<template lang="pug">
.view-platform
  ui-navbar-panel.mb-20(backLink="platforms", backLinkText="К списку")
    template(slot="filters")
      span Новая платформа

    template
      b-button.is-primary(@click="save", icon-left="check") Сохранить

  .container
    form-component(
      v-model="platform",
      form="new-platform-form",
      ref="form",
      @afterCreate="routeToPlatform"
    )
</template>

<script>
import Platform from '@/models/Platform';
import BButton from 'buefy/src/components/button/Button';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';

export default {
  name: 'view-new-platform',

  components: { BIcon, BField, BButton },

  data: () => ({
    platform: new Platform(),
  }),

  methods: {
    save() {
      this.$refs.form.save();
    },

    routeToPlatform({ id }) {
      this.$router.replace({ name: 'editPlatform', params: { id } });
    },
  },
};
</script>
